"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.parse-int.js");

var _popup = require("element-ui/lib/utils/popup");

var _vdom = require("element-ui/lib/utils/vdom");

var _vue = _interopRequireDefault(require("vue"));

var _notification = _interopRequireDefault(require("./notification.js"));

// import { remFontSize } from 'sk-utils'
// import {t} from 'sk-utils'
var NotificationConstructor = _vue["default"].extend(_notification["default"]);

var instance;
var instances = [];
var seed = 1;
var staticOffsetMap = {};

var Notification = function Notification(options) {
  if (_vue["default"].prototype.$isServer) return;
  options = options || {};
  var userOnClose = options.onClose;
  var id = options.id || 'notification_' + seed++;
  var index = instances.findIndex(function (d) {
    return d.id === id;
  });
  var position = options.position || 'top-right';
  var offset = staticOffsetMap[position] || 0;

  if (index >= 0) {
    instance = instances[index];
    instance.message = options.message;
    instance.duration = options.duration; // 扩展开启快捷键

    instance.openKeyAll = options.openKeyAll; // 扩展scrollbar

    instance.scrollbar = options.scrollbar;
    instance.maxHeight = options.maxHeight;
    instance.maxHeightOffset = options.maxHeightOffset;
    instance.container = options.container; // 扩展scrollbar

    if (options.restart) {
      instance.clearTimer();
      instance.startTimer();
    } // else {


    instance.type = options.type;
    instance.$nextTick(function () {
      // 重新调整位置
      Notification.updatePosition(offset);
    }); // }

    return instance;
  }

  options.onClose = function () {
    Notification.close(id, userOnClose);
  };

  instance = new NotificationConstructor({
    data: options
  });

  if ((0, _vdom.isVNode)(options.message)) {
    instance.$slots["default"] = [options.message];
    options.message = 'REPLACED_BY_VNODE';
  }

  instance.id = id;
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.visible = true;
  instance.dom = instance.$el;
  instance.dom.style.zIndex = _popup.PopupManager.nextZIndex();
  var verticalOffset = options.offset || 0;
  instance._options = options; // 扩展 允许消息框重叠

  instance.overlapable = options.overlapable;
  var offsetHeight = 16; // const offsetHeight = remFontSize(16)

  if (!options.overlapable) {
    instances.filter(function (item) {
      return item.position === position;
    }).forEach(function (item) {
      verticalOffset += item.$el.offsetHeight + offsetHeight;
    });
  }

  verticalOffset += offset ? 0 : offsetHeight;
  instance.verticalOffset = verticalOffset + offset;
  instances.push(instance); // 当每次有新的instance生成时，重新调整一次所有instance的位置，防止同时触发多个instance时出现重叠问题

  instance.$nextTick(function () {
    // 重新调整位置
    Notification.updatePosition(offset);
  });
  return instance;
};

['success', 'warning', 'info', 'error'].forEach(function (type) {
  Notification[type] = function (options) {
    if (typeof options === 'string' || (0, _vdom.isVNode)(options)) {
      options = {
        message: options
      };
    }

    options.type = type;
    return Notification(options);
  };
});

Notification.close = function (id, userOnClose) {
  var index = -1;
  var len = instances.length;
  var instance = instances.filter(function (instance, i) {
    if (instance.id === id) {
      index = i;
      return true;
    }

    return false;
  })[0];
  if (!instance) return;

  if (typeof userOnClose === 'function') {
    userOnClose(instance);
  }

  instances.splice(index, 1); // if (instance) {
  //   instance.close();
  // }

  if (len <= 1) return;
  var position = instance.position;
  var removedHeight = instance.dom.offsetHeight; // 扩展 允许消息框重叠

  if (!instance.overlapable) {
    for (var i = index; i < len - 1; i++) {
      if (instances[i].position === position) {
        instances[i].dom.style[instance.verticalProperty] = parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
      }
    }
  }
};

Notification.closeIntance = function (id) {
  var instance = instances.filter(function (instance, i) {
    if (instance.id === id) {
      return true;
    }

    return false;
  })[0];
  if (!instance) return;
  instance.close();
};

Notification.closeAll = function () {
  for (var i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

Notification.getInstanceNum = function () {
  return instances.length;
};

Notification.updatePosition = function (offset) {
  // 重新调整位置
  offset = offset || 0;

  for (var i = 1, len = instances.length; i < len; i++) {
    var _instance = instances[i];
    var verticalOffset = _instance._options.offset || 0;

    for (var j = 0, len1 = i; j < len1; j++) {
      var item = instances[j];
      verticalOffset += item.$el.offsetHeight + 16;
    }

    verticalOffset += offset ? 0 : 16;
    _instance.verticalOffset = verticalOffset + offset;
  }
};

Notification.updateStaticOffset = function () {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'bottom-right';

  var _instaces = instances.filter(function (item) {
    return item.position === position;
  });

  staticOffsetMap[position] = offset;

  if (!_instaces.length) {
    return;
  }

  _instaces[0].verticalOffset = offset;
  Notification.updatePosition(offset);
};

var _default = Notification;
exports["default"] = _default;